import React from 'react';
import EmployeeLink from '@/components/common/EmployeeLink';
import InteractionEnumIcon from '@/components/common/InteractionEnumIcon';
import RouterLink from '@/components/common/RouterLink';
import intl from '@/lib/intl/intl';
import translate from '@/lib/intl/translate';
import type Constituent from '@/types/api/Constituent';
import EntityDate from './EntityDate';

const CLASSES = {
  experience: {
    icon: 'inline-block ml-1 mb-[3px]',
  },
  interaction: {
    icon: 'inline',
  },
};

type InteractionSummaryProps = {
  constituent: Constituent;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entity: any;
};

export default function InteractionSummary({
  constituent,
  entity,
}: InteractionSummaryProps) {
  const {
    developers,
    interactionDate,
    interactionId,
    interactionTypeEnum,
    sentiment,
  } = entity;

  return (
    <div>
      {interactionTypeEnum &&
        translate(
          `INTERACTION_ENTITY_${interactionTypeEnum.toUpperCase()}_SUMMARY`,
          {
            constituentLink: (
              <RouterLink to={`/constituent/${constituent.constituentId}`}>
                {constituent.displayName}
              </RouterLink>
            ),
            interactionIcon: (
              <InteractionEnumIcon
                classes={CLASSES.interaction}
                enumValue={interactionTypeEnum}
                iconOnly
                type={InteractionEnumIcon.interactionType}
              />
            ),
            developers: intl.formatList(
              developers.map(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
                ({ displayName: developerDisplayName, userId }: any) => (
                  <EmployeeLink
                    key={userId}
                    displayName={developerDisplayName}
                    userId={userId}
                  />
                ),
              ),
              { type: 'conjunction' },
            ),
            hasDevelopers: !!developers.length,
            date: (
              <EntityDate
                entityId={interactionId}
                dateString={interactionDate}
              />
            ),
          },
        )}
      {sentiment && (
        <InteractionEnumIcon
          classes={CLASSES.experience}
          enumValue={sentiment}
          iconOnly
          type={InteractionEnumIcon.experienceType}
        />
      )}
    </div>
  );
}
